import React from 'react';
import type { CaseEntry } from '../../../types/caseEntry';
import { formatHours } from '../../../utils/caseEstimate';
import { EntryRow } from './EntryRow';
interface HoursSectionProps {
  /** Estimerede timer fra tilbuddet — null når sagen ikke har et tilbud. */
  estimatedHours: number | null;
  entries: CaseEntry[];
  onEdit: (entry: CaseEntry) => void;
  onDelete: (entry: CaseEntry) => void;
}
export function HoursSection({
  estimatedHours,
  entries,
  onEdit,
  onDelete
}: HoursSectionProps) {
  return <div data-id="element-195" data-mp="2mtcohh4xohxu">
      {estimatedHours !== null && <p className="text-sm text-ink-muted" data-id="element-196" data-mp="2mv5tyt3t8w49">
          Estimeret fra tilbud: <span className="font-medium text-ink" data-id="element-197" data-mp="283f6xk1ieqhm">{formatHours(estimatedHours)}</span>
        </p>}
      {entries.length === 0 ? <p className="mt-2 text-sm text-ink-muted" data-id="element-198" data-mp="2d0x4kea2tjab">Ingen timer registreret endnu.</p> : <ul className="mt-1 divide-y divide-line/70" data-id="element-199" data-mp="30r17skjcrh0s">
          {entries.map(entry => <EntryRow key={entry.id} entry={entry} onEdit={onEdit} onDelete={onDelete} data-id="element-200" data-mp="35lnmoxon7rpm" />)}
        </ul>}
    </div>;
}